import { FC } from 'react';

import { StyledChip, StyledDeleteButton, StyledIconWrapper, StyledLabel } from './Chip.styled';
import type { ChipProps } from './types';

const CloseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.99999 7.05714L11.3 3.75714L12.2427 4.69981L8.94266 7.99981L12.2427 11.2998L11.3 12.2425L7.99999 8.94247L4.69999 12.2425L3.75732 11.2998L7.05732 7.99981L3.75732 4.69981L4.69999 3.75714L7.99999 7.05714Z"
      fill="currentColor"
    />
  </svg>
);

const Chip: FC<ChipProps> = ({
  label,
  size = 'md',
  roundness = 'default',
  selected = false,
  disabled = false,
  startIcon,
  onClick,
  onDelete,
  deleteLabel,
  className,
  tabIndex,
}) => {
  const isInteractive = Boolean(onClick) && !disabled;

  return (
    <StyledChip
      $size={size}
      $roundness={roundness}
      $selected={selected}
      aria-disabled={disabled || undefined}
      aria-pressed={onClick ? selected : undefined}
      onClick={!disabled ? onClick : undefined}
      className={className}
      tabIndex={isInteractive ? (tabIndex ?? 0) : undefined}
      role={onClick ? 'button' : undefined}
    >
      {startIcon && (
        <StyledIconWrapper $size={size} data-chip-icon>
          {startIcon}
        </StyledIconWrapper>
      )}

      <StyledLabel>{label}</StyledLabel>

      {onDelete && (
        <StyledDeleteButton
          $size={size}
          data-chip-delete
          type="button"
          onClick={(e) => {
            e.stopPropagation();
            if (!disabled) onDelete(e);
          }}
          disabled={disabled}
          aria-label={deleteLabel ?? (typeof label === 'string' ? `Remove ${label}` : 'Remove')}
        >
          <CloseIcon />
        </StyledDeleteButton>
      )}
    </StyledChip>
  );
};

Chip.displayName = 'Chip';

export default Chip;
